import { gql } from 'apollo-angular';

export var update_acq_notes = gql`
  mutation updateAcquisitionsNotes($id: ID!, $notes: String!) {
    updateNotes(id: $id, notes: $notes){
      id, notes
    }
  }
`;

export var update_synd_notes = gql`
  mutation updateSyndicationsNotes($id: ID!, $syndications_notes: String!) {
    updateSyndicationsNotes(id: $id, syndications_notes: $syndications_notes){
      id, syndications_notes
    }
  }
`;
